document.addEventListener("DOMContentLoaded", () => {
	const container = document.querySelector("#mfcf7_zl_multifilecontainer");
	const addButton = document.querySelector(".qbutton");

	if (!container || !addButton) return;

	const originalButtonText = addButton.value;
	const buttonParent = addButton.closest("p");

	if (!buttonParent) return;

	const hiddenWrap = container.parentElement?.querySelector(
		".wpcf7-form-control-wrap.zl-form-control-wrap.multilinefile-592"
	);
	if (hiddenWrap) {
		hiddenWrap.style.display = "none";
	}

	let maxFilesMessage = document.querySelector(".max-files-message");
	if (!maxFilesMessage) {
		maxFilesMessage = document.createElement("p");
		maxFilesMessage.className = "max-files-message complain-form__list-item _text_1iazp_25";
		maxFilesMessage.textContent =
			"Добавлено максимальное количество файлов. Удалите файл, чтобы загрузить другой.";
		maxFilesMessage.style.display = "none";
		buttonParent.insertAdjacentElement("afterend", maxFilesMessage);
	}

	const checkFilesCount = () => {
		const fileNames = container.querySelectorAll(".mfcf7-zl-multifile-name");
		const addedFiles = Array.from(fileNames).filter(
			(el) => el.textContent.trim().length > 0
		).length;

		const isMaxFiles = addedFiles >= 10;

		if (isMaxFiles) {
			addButton.style.display = "none";
			maxFilesMessage.style.display = "block";
		} else {
			addButton.style.display = "";
			maxFilesMessage.style.display = "none";
		}

		addButton.value =
			addedFiles >= 1 ? "Добавить еще файл" : originalButtonText;
	};

	checkFilesCount();

	const observer = new MutationObserver(checkFilesCount);
	observer.observe(container, {
		childList: true,
		subtree: true,
		characterData: true,
	});
});
